/**
 * Component to display info and error messages with dismissible alerts
 */

import React from 'react';
import { Alert, Stack } from '@mui/material';

interface ShowInfoMessagesProps {
  infoMessage: string | null;
  errorMessage: string | null;
  onClearInfo: () => void;
  onClearError: () => void;
}

export const ShowInfoMessages: React.FC<ShowInfoMessagesProps> = ({
  infoMessage,
  errorMessage,
  onClearInfo,
  onClearError,
}) => {
  if (!infoMessage && !errorMessage) {
    return null;
  }

  return (
    <Stack spacing={2} sx={{ mb: 2 }}>
      {infoMessage && (
        <Alert severity="info" onClose={onClearInfo}>
          {infoMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error" onClose={onClearError}>
          {errorMessage}
        </Alert>
      )}
    </Stack>
  );
};
